export enum RiskAssessmentTemplateResourceType {
  DELIVERY = "DELIVERY",
  LOCATION = "LOCATION",
  ORGANISATION = "CONNECTION",
  PRODUCT = "PRODUCT",
  MATERIAL = "MATERIAL",
  COUNTRY = "COUNTRY",
}
